import React from 'react';
import { LoadingPlaceholder, theme, VStack } from '@sweetgreen/garnish';

import { useLocalizationContext } from '@order/Localization';
import { useTrackEffect } from '@order/Telemetry';

import { CreditMenuItem } from './CreditMenuItem';

export const CreditMenu = ({
  creditAmount,
  isLoadingCredits,
  onPressAddPromoCode,
  onPressAvailableCredit,
}: CreditMenuProps): React.ReactElement => {
  useTrackEffect('payment_credit.view_credit');
  const { t, formatPrice } = useLocalizationContext();

  return (
    <VStack customSpacing={0} divider={true} dividerColor={theme.colors.LIGHT}>
      {isLoadingCredits ? (
        <LoadingPlaceholder rows={1} rowHeight={100} palette="darkGray" />
      ) : (
        <CreditMenuItem
          testID="account.available-credit-details-button"
          accessibilityLabel={t('account.credit.label')}
          accessibilityHint={t('account.credit.label')}
          iconName="IconCredit"
          title={t('account.credit.mobile-label')}
          subtitle={formatPrice(creditAmount, 'USD')}
          onPress={onPressAvailableCredit}
        />
      )}
      <CreditMenuItem
        testID="account.open-promo-code-selection-button"
        accessibilityLabel={t('account.credit.a11y-label')}
        accessibilityHint={t('account.credit.a11y-label')}
        iconName="IconPromo"
        title={t('account.credit.field-placeholder')}
        onPress={onPressAddPromoCode}
      />
    </VStack>
  );
};

export type CreditMenuProps = {
  readonly creditAmount: number;
  readonly isLoadingCredits?: boolean;
  readonly onPressAvailableCredit: () => void;
  readonly onPressAddPromoCode: () => void;
};
